"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createServiceMiddleware = void 0;
/**
 * create a middleware based on middleware service
 * @param service the service will be used in this middleware
 */
function createServiceMiddleware(service) {
    return (store) => (next) => (action) => {
        const result = service.invoke(action);
        const nextResult = next(action);
        return result.isMiddlewareResult ? result.value : nextResult;
    };
}
exports.createServiceMiddleware = createServiceMiddleware;
